import React, { useMemo, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import api from '../services/api';

const previewCopy = {
  analysis: {
    title: 'AI Analiz Odasi',
    text: 'Detayli yapay zeka yorumu, guven skoru, market dagilimi ve editor secimi premium uyelikle acilir.'
  },
  winningPremiumCoupons: {
    title: 'Tutan Premium Kuponlar',
    text: 'Gecmis premium kupon performansi, tam kupon detaylari ve premium kupon mantigi burada gorunur.'
  },
  risky: {
    title: 'Riskli Denenebilir',
    text: 'Yuksek oranli ama secilmis marketler, sadece premium tarafta detayli olarak acilir.'
  },
  coupons: {
    title: 'Premium Kuponlar',
    text: 'Gunluk premium kuponlar, editor secimleri ve poster gorunumu premium uyelikte yer alir.'
  },
  opportunities: {
    title: 'VALUE BET',
    text: 'Modelin piyasa olasiligini gectigi, pozitif edge tasiyan secimler bu alanda gorunur.'
  },
  liveCoupon: {
    title: 'Canli Kupon',
    text: 'Cok guclu canli sinyal gecen en fazla 2 maclik poster kuponu sadece premium tarafta acilir.'
  }
};

const PremiumPreview = () => {
  const location = useLocation();
  const { user, refreshUser } = useAuth();
  const [requestLoading, setRequestLoading] = useState(false);
  const [requestMessage, setRequestMessage] = useState('');
  const featureKey = new URLSearchParams(location.search).get('feature') || 'analysis';
  const content = useMemo(() => previewCopy[featureKey] || previewCopy.analysis, [featureKey]);

  if (featureKey === 'analysis') {
    return <Navigate to="/analysis" replace />;
  }

  const handlePremiumRequest = async () => {
    try {
      setRequestLoading(true);
      setRequestMessage('');
      const data = await api.requestPremiumUpgrade();
      await refreshUser();
      setRequestMessage(data.message || 'Premium talebiniz admine iletildi.');
    } catch (error) {
      setRequestMessage(error.message);
    } finally {
      setRequestLoading(false);
    }
  };

  return (
    <div className="page analysis-page">
      <section className="hero-panel compact premium-preview-hero">
        <div className="hero-copy">
          <span className="hero-badge">Premium Vitrin</span>
          <h1>{content.title}</h1>
          <p>{content.text}</p>
        </div>
      </section>

      <div className="analysis-card premium-preview-card">
        <div className="analysis-header">
          <span>Bu alan premium uyelere ozel</span>
          <span className="confidence high">Premium</span>
        </div>
        <p className="analysis-summary premium-preview-lead">
          Normal uye olarak menude bu bolumu goruyorsun. Icine tam erisim icin premium uyelik gerekir.
        </p>
        <div className="premium-live-lock premium-live-lock-blink analysis-lock-banner">
          ANALIZ ICIN LUTFEN PREMIUM UYE OLUNUZ
        </div>
        <button
          type="button"
          className="btn-primary"
          onClick={handlePremiumRequest}
          disabled={requestLoading || user?.premiumRequestPending}
        >
          {user?.premiumRequestPending ? 'Talep Gonderildi' : requestLoading ? 'Gonderiliyor...' : 'Premium Ol'}
        </button>
        {requestMessage ? <small className="premium-request-feedback">{requestMessage}</small> : null}
      </div>
    </div>
  );
};

export default PremiumPreview;
